<template>
    <v-row dense>
        <v-col class="v-flex">
            <v-checkbox
                v-model = "selected"
                class   = "mt-0"
                :ripple = "false"
                @click  = "onClick"
                hide-details
            >
                <template v-slot:label>
                    <div class="v-flex">
                        <div class="filter-icon">
                            <v-icon size="16" :color="color">{{ icon }}</v-icon>
                        </div>
                        <div class="ml-0">
                            {{ label  }}
                        </div>
                    </div>
                </template>
            </v-checkbox>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "CrmEntryFilterMenuEntry",

    props: {
        value: {

        },

        icon: {

        },

        label: {

        },

        color: {
            required: false,
            default : () => {
                return "primary";
            }
        }
    },

    data: () => ({
        selected: false,
    }),

    mounted() {
        this.selected = this.value;
    },

    watch: {
        value () {
            this.selected = this.value;
        }
    },

    methods: {
        onClick () {
            this.$emit("input", this.selected);
        }
    }
}
</script>

<style scoped>

.filter-icon {
    width: 25px;
    margin-top: -1px;
}

</style>